const cleanWord = (word: string) =>
  word
    .normalize('NFD')
    /**
     * Remove Diacritical Symbols except ~ (\u0303)
     * @see https://www.unicode.org/charts/PDF/U0300.pdf
     */
    .replace(/[\u0300-\u0302]|[\u0304-\u036f]/g, '')
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      '',
    );

const hasOfensiveWord = (word: string, dictionaryWord: string) =>
  cleanWord(word)
    .toLowerCase()
    .indexOf(cleanWord(dictionaryWord).toLowerCase()) !== -1;

export const censureOfensiveWords = (
  word: string,
  dictionary: string[],
): { wasCensured: boolean; censuredWord: string } => {
  let hasWords = false;

  dictionary.every((dictWord: string) => {
    if (hasOfensiveWord(word, dictWord)) {
      /**
       * Delimited word
       * Detecting independient words: regexp `\bJava\b` will be found in `Hello, Java!`,
       * where `Java` is a standalone word, but not in `Hello, JavaScript!`
       * @see https://javascript.info/regexp-boundary
       */
      const delimitedWord = new RegExp(`\\b${cleanWord(dictWord)}\\b`, 'i');
      const cleanedWord = cleanWord(word);
      const censuredWord = cleanedWord.replace(
        delimitedWord,
        '*'.repeat(dictWord.length),
      );

      if (censuredWord !== cleanedWord) {
        hasWords = true;
        word = censuredWord;
      }
    }

    return !hasWords;
  });

  return { wasCensured: hasWords, censuredWord: word };
};
